import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { AnnouncementAction, AnnouncementGetter } from '@/store/announcement/announcement.module';
import { Announcement, AnnouncementAttachment } from '@/store/announcement/announcement.model';
import AnnouncementFormComponent from '@/components/announcementForm/AnnouncementForm.vue';
import AnnouncementImageComponent from '@/components/announcementModal/announcementImage/AnnouncementImage.vue';
import AnnouncementDocumentComponent from '@/components/announcementModal/announcementDocument/AnnouncementDocument.vue';
import AnnouncementUploadComponent from '@/components/announcementModal/announcementUpload/AnnouncementUpload.vue';

export default defineComponent({
  name: 'AnnouncementDetailComponent',
  components: {
    AnnouncementFormComponent,
    AnnouncementImageComponent,
    AnnouncementDocumentComponent,
    AnnouncementUploadComponent,
  },
  setup: () => {
    const router = useRouter();
    const route = useRoute();
    const announcementId = computed<number>(() => parseInt(route.params.announcementId as string));
    const store = useStore();
    const announcement = computed<Announcement | undefined>(() => store.getters[AnnouncementGetter.BY_ID](announcementId.value));
    const documents = computed<AnnouncementAttachment[]>(() => (announcement.value) ? announcement.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<AnnouncementAttachment[]>(() => (announcement.value) ? announcement.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const announcementForm = ref<InstanceType<typeof AnnouncementFormComponent>>();
    const announcementImage = ref<InstanceType<typeof AnnouncementImageComponent>>();
    const announcementDocument = ref<InstanceType<typeof AnnouncementDocumentComponent>>();
    const announcementUpload = ref<InstanceType<typeof AnnouncementUploadComponent>>();

    onMounted(() => {
      store.dispatch(AnnouncementAction.FETCH);
    });

    const editClick = () => {
      announcementForm.value?.show();
    };

    const imageClick = () => {
      announcementImage.value?.show();
    };

    const documentClick = () => {
      announcementDocument.value?.show();
    };

    const redirect = () => {
      router.push('/announcement');
    };

    const handleUpload = () => {
      announcementUpload.value?.show();
    };

    const handleHidden = () => {
      announcementDocument.value?.show();
    };

    return {
      announcement,
      documents,
      images,
      announcementForm,
      announcementImage,
      announcementDocument,
      announcementUpload,
      editClick,
      imageClick,
      documentClick,
      redirect,
      handleUpload,
      handleHidden,
    };
  }
});
